module.exports = __webpack_public_path__ + "assets/img/button-read.7ed907a3.png";